module.exports = __webpack_public_path__ + "images/pages/for_business/sp/btn_2_15ef7182bcb5dbe4666dda98d0696e8c.png";